export default __webpack_public_path__ + "static/media/walletconnect.986542a2.svg";